import { render, staticRenderFns } from "./CreateRule.vue?vue&type=template&id=79ae3daa&scoped=true&"
import script from "./CreateRule.vue?vue&type=script&lang=js&"
export * from "./CreateRule.vue?vue&type=script&lang=js&"
import style0 from "./CreateRule.vue?vue&type=style&index=0&id=79ae3daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae3daa",
  null
  
)

export default component.exports